import $ from "jquery";

export const initCourseCollapse = () => {
    $(function () {
        $(".topics .category .info .categoryname").on("click", function(e) {
            $(this).parent().parent().toggleClass("collapsed");
        });
    });
};
